export const flightsRoutes = {
  create: [],
  view: [
    {
      path: 'flights',
      title: `trip flights`,
      loadComponent: () =>
        import('./pages/flights-section/flights-section.page').then((m) => m.FlightsSectionPage),
    },
  ],
};
